/**
 * Checks if a value is null.
 *
 * @param val - The value to check.
 * @returns A boolean indicating whether the value is null or not.
 */

export function isNull(val: unknown): val is null {
  return val === null
}
